import React, { useEffect } from 'react';
import '@radix-ui/themes/styles.css';
import { Footer } from '../../organisms/footer/Footer';
import { Navigation } from '../../organisms/navigation/Navigation';
import clsx from 'clsx';
import { Notice } from '../../molecules/notice/Notice';
import {
	getUTMParams,
	getSourceFromReferrer,
	handleUtmParams,
} from '../../../utils/tracking';
import Cookies from 'js-cookie';

type Props = {
	children: string | JSX.Element | JSX.Element[];
	theme?: 'light' | 'dark';
	layoutClass?: string;
	showFooter?: boolean;
	showNav?: boolean;
	brand?: 'default' | 'xero' | 'myob' | 'vow';
	limitFooter?: boolean;
	limitNav?: boolean;
};

export function Layout({
	children,
	brand,
	theme = 'dark',
	layoutClass,
	showFooter = true,
	showNav = true,
	limitFooter = false,
	limitNav = false,
}: Props) {
	useEffect(() => {
		if (typeof window === 'undefined') {
			return;
		}

		const { currentUTM, shouldUpdate, shouldNotUpdate } = handleUtmParams();

		// We should update the existing UTM parameters if the UTM search params is empty AND
		// The current source is 'Direct' and the existing source is populated
		if (shouldNotUpdate) {
			return;
		}

		if (shouldUpdate) {
			Cookies.set('utm_params', JSON.stringify(currentUTM), { expires: 30 });
		}
	});
	return (
		<React.Fragment>
			<div className={clsx('w-screen relative overflow-hidden', layoutClass)}>
				{showNav ? <Navigation theme={theme} brand={brand} /> : null}
				{children}
				{showFooter ? <Footer limited={limitFooter} /> : null}
			</div>
		</React.Fragment>
	);
}
